import get from 'lodash.get';
import { PERIOD } from '../../constants/enrollment';
import { MEASURE_NAMES } from '../../constants/assessments';

/**
 * 1. Look into TRC BM status for a given period for explicit PM recommendation
 * 2. Get latest TRC PM result date
 * 3. Return TRC as recommended measure if BM status suggests PM necessity
 *  and there are no PM results past given period benchmark completion, recommend nothing otherwise
 * @param {Object} appStatus - object containing TRC BM status in R3D or R3D Spanish app
 * @param {Object} studentResults - TRC results grouped by period
 */
export const getTRCRecommendation = (appStatus, studentResults) => {
    const recommendedR3DMeasures = [];
    if (appStatus.isPMRecommended) {
        const completePMResultsPostBM = get(studentResults, PERIOD.PM, []).filter(
            result =>
                result.isComplete &&
                new Date(result.clientModDate) > new Date(appStatus.completionDate),
        );
        if (!completePMResultsPostBM.length) {
            recommendedR3DMeasures.push(MEASURE_NAMES.TRC);
        }
    }

    return recommendedR3DMeasures;
};
